import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import HeroCarouselItem, {
  HeroCarouselItemProps,
} from 'components/helpers/CarouselItem/HeroCarouselItem';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { pushCarouselClickDataLayerObject } from 'lib/util/gtm-datalayer';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { classnames } from 'tailwindcss-classnames';

export type HeroCarouselProps = Sitecore.Override.ComponentBase &
  Components.Heroes.HeroCarousel.Fields.HeroCarousel;

const HeroCarousel = ({ fields }: HeroCarouselProps): JSX.Element => {
  if (!fields) {
    return <MissingDataSource />;
  }
  const carouselItems = fields.carouselItems.map((item) => {
    return {
      ...item,
    } as HeroCarouselItemProps;
  });

  let clickAction = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleRealIndexChange = async (swiper: any) => {
    // eslint-disable-next-line no-promise-executor-return
    await new Promise((r) => setTimeout(r, 200));
    pushCarouselClickDataLayerObject(swiper.realIndex, clickAction, 'hero carousel', carouselItems);
    clickAction = '';
  };
  const handlePrev = () => {
    clickAction = 'carousel - left click';
  };
  const handleNext = () => {
    clickAction = 'carousel - right click';
  };

  return (
    <section data-component="authorable/Heroes/heroCarousel" className="hero-carousel">
      <div className={classnames('my-10', 'md:my-16')}>
        <Swiper
          loop={carouselItems.length > 1}
          slidesPerView={1}
          spaceBetween={0}
          navigation={{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }}
          pagination={{
            clickable: true,
            el: '.swiper-pagination',
            bulletElement: 'button',
          }}
          onRealIndexChange={handleRealIndexChange}
        >
          {carouselItems.map((carouselItem, index) => (
            <SwiperSlide key={carouselItem.id}>
              <HeroCarouselItem {...carouselItem} index={index} carouselName={carouselItem.name} />
            </SwiperSlide>
          ))}
          {carouselItems.length > 1 && (
            <div slot="container-end" className={classnames('mt-10')}>
              <div className={classnames('m-auto', 'flex', 'h-6', 'w-max', 'items-center')}>
                <button type="button" className="swiper-button-prev" onClick={handlePrev}>
                  prev
                </button>
                <div className="swiper-pagination" />
                <button type="button" className="swiper-button-next" onClick={handleNext}>
                  next
                </button>
              </div>
            </div>
          )}
        </Swiper>
      </div>
    </section>
  );
};

export default HeroCarousel;
